import { render, staticRenderFns } from "./PadMenuVariant.vue?vue&type=template&id=fd7bdada&"
import script from "./PadMenuVariant.vue?vue&type=script&lang=js&"
export * from "./PadMenuVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports